import React from 'react';
import '../../CSS/AttendanceDetailsModel.css';
import {Card} from '@material-ui/core';
import {motion} from 'framer-motion';

function Model(props) {
    var index = props.index;
    var details = props.item;

    const pageVariants = {
        initial :{
            opacity: 0,
            scale: 0.5
        },
        in:{
            opacity: 1,
            scale: 1
        },
      };
      
      const pageTransition = {
        type: "tween",
        ease: "anticipate",
        duration: index*0.15
      };

    return(
        <div className="MainModel"
        initial="initial"
        animate="in"
        variants={pageVariants}
        transition={pageTransition}>
            <Card
            raised
            className="CardDetails"
            style={{
                borderRadius:"5px",
            }}>

                <div
                className="Box1">
                    <div
                    className="Date">
                        Date : {details.date}
                    </div>
                    
                    <div
                    className="Present">
                        Present : {details.present}
                    </div>

                </div>                
                
                <div
                className="Box2">
                    <div 
                    className="TimeModel">
                        Time : {details.time}
                    </div>
                    
                    <div
                    className="Absent">
                        Absent : {details.absent}
                    </div>
                </div>
            </Card>
            
        </div>
    );
}

export default Model;